// axios
import axios from 'axios';
import cachios from 'cachios';

const defaultAxios = axios.create({
  baseURL: process.env.VUE_APP_ROOT_DEFAULT_API,
  withCredentials: true,
});

const labsAxios = axios.create({
  baseURL: process.env.VUE_APP_ROOT_LABS_API,
});

const cachedAxios = cachios.create(defaultAxios);

export { defaultAxios, cachedAxios, labsAxios };
